export default __webpack_public_path__ + "static/media/blog-img80.39dbdd92.jpg";